import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { AppDialogTitle } from './app-dialog-title';
import { AppDialogActions } from './app-dialog-actions';

// ----------------------------------------------------------------------

export function ConfirmDialog({
  title,
  content,
  action,
  open,
  onClose,
  cancelLabel = 'Cancel',
  ...other
}) {
  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
      <AppDialogTitle title={title} onClose={onClose} />

      {content && <DialogContent sx={{ pt: 3, typography: 'body2' }}> {content} </DialogContent>}

      <AppDialogActions>
        {action}

        <Button variant="outlined" color="inherit" onClick={onClose}>
          {cancelLabel}
        </Button>
      </AppDialogActions>
    </Dialog>
  );
}
